import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'pascalCase'})
export class PascalCasePipe implements PipeTransform {

  transform(word: any): string {
    if (!word) {
      return word;
    }
    return word.toString()
      .split('.')
      .filter((x: string) => !!x && x.length > 0)
      .map((x: string) => x[0].toUpperCase() + x.substring(1))
      .join('.');
  }
}
